import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from './api';

export type BookingHeadCategory = 'CLIENT_BOOKING' | 'OPERATING_EXPENSE';

export type BookingHeadRow = {
  id: string;
  key: string;
  label: string;
  category: BookingHeadCategory;
  isSeeded: boolean;
  active: boolean;
};

export function useBookingHeads() {
  return useQuery({
    queryKey: ['booking-heads'],
    queryFn: async () => {
      const r = await api<{ heads: BookingHeadRow[] }>('/api/booking-heads');
      return r.heads;
    },
    staleTime: 60_000,
  });
}

export function useCreateBookingHead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: { label: string; category: BookingHeadCategory }) => {
      const r = await api<{ head: BookingHeadRow }>('/api/booking-heads', {
        method: 'POST',
        body: input,
      });
      return r.head;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['booking-heads'] });
    },
  });
}

export function headLabel(key: string | null | undefined, heads?: BookingHeadRow[]): string {
  if (!key) return '';
  const found = heads?.find((h) => h.key === key);
  if (found) return found.label;
  return key.toLowerCase().replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}
